import { TextComponent } from 'baseComponents/TextComponent';
import { Spin } from 'antd';
import './estimationChannelCard.scss';

type EstimationChannelCardProps = {
  title: string;
  hasCredits: boolean;
  estimatedAudience?: number;
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
  loading?: boolean;
};

export const EstimationChannelCard = ({
  title,
  hasCredits,
  estimatedAudience,
  onClick,
  disabled = false,
  selected = false,
  loading = false,
}: EstimationChannelCardProps) => {
  const isClickable = !disabled && !loading;
  const baseClassName = 'estimation-channel-card';
  const className = [
    baseClassName,
    hasCredits ? `${baseClassName}--has-credits` : `${baseClassName}--no-credits`,
    disabled && `${baseClassName}--disabled`,
    selected && `${baseClassName}--selected`,
    loading && `${baseClassName}--loading`,
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = isClickable ? onClick : undefined;

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={isClickable ? 0 : -1}
      aria-disabled={!isClickable}
      className={className}
    >
      <TextComponent text={title} weight="extra-bold" size="large" inline />
      <div className={`${baseClassName}__content`}>
        {disabled ? (
          <TextComponent text="⚠️ No audience selected ⚠️" />
        ) : (
          <>
            {loading ? (
              <div className='estimation-channel-card__loading-content'>
                <Spin size="small" />
              </div>
            ) : (
              <TextComponent
                text={
                  estimatedAudience !== undefined && estimatedAudience !== null
                    ? `Estimated audience: ${estimatedAudience.toLocaleString('en-GB')}`
                    : 'Estimated audience: —'
                }
              />
            )}
            {!hasCredits && !loading && <TextComponent text="⚠️ Insufficient Credits ⚠️" />}
            {!loading && (<TextComponent
              inline
              text={hasCredits ? 'Click to compose' : 'Click to purchase'}
              className={`${baseClassName}__cta-text`}
            />)}
          </>
        )}
      </div>
    </div>
  );
};
